import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../../shared/loading-panel/loading-panel.service';
import { MonitorSchedule } from '../../models/monitor-schedule';
import { MonitorService } from '../../services/monitor.service';
import { SvgIconComponent } from '../../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { MonitorSchedulesGridComponent } from '../monitor-schedules-grid/monitor-schedules-grid.component';

@Component({
  selector: 'app-monitor-schedules',
  templateUrl: './monitor-schedules.component.html',
  styleUrls: ['./monitor-schedules.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, MonitorSchedulesGridComponent]
})
export class MonitorSchedulesComponent implements OnInit {
  private loadingPanelService = inject(LoadingPanelService);
  private monitorService = inject(MonitorService);

  monitorSchedules = signal<MonitorSchedule[]>([]);

  ngOnInit(): void {
    void this.refresh();
  }

  async refresh(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading monitor schedules...');
      this.monitorSchedules.set(await this.monitorService.getMonitorSchedules());
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  async onSaveSchedule(schedule: MonitorSchedule): Promise<void> {
    const saved = await this.monitorService.saveMonitorSchedule(schedule);
    // eslint-disable-next-line require-atomic-updates
    schedule.Id = saved.Id;
    // eslint-disable-next-line require-atomic-updates
    schedule.ScheduledItem.Id = saved.ScheduledItem?.Id;
  }

  async onDeleteSchedule(schedule: MonitorSchedule): Promise<number> {
    const rows = await this.monitorService.deleteMonitorSchedule(schedule.Id);
    return rows;
  }
}
